import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="relative bg-white border-t border-neutral-100 text-slate-500">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-[url('/grid-pattern-light.svg')] bg-center opacity-[0.02]"></div>
      </div>

      {/* Footer Content */}
      <div className="page-container relative py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          <div>
            <h3 className="text-slate-900 font-medium text-base mb-3">Arterra.AI</h3>
            <p className="text-slate-500 text-xs leading-relaxed">
              Decision intelligence for private markets—real assets delivered in minutes.
            </p>
          </div>

          <div>
            <h4 className="font-medium text-slate-900 text-xs uppercase tracking-wider mb-3">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/projects" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs">
                  Browse Projects
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/book-demo" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs">
                  Book a Demo
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-slate-900 text-xs uppercase tracking-wider mb-3">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-slate-900 text-xs uppercase tracking-wider mb-3">Connect</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www.linkedin.com/company/arterra-ai/" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs inline-flex items-center">
                  <svg className="w-3 h-3 mr-1 opacity-75" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="https://x.com/arterra_ai" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-amber-600 transition-colors duration-300 text-xs inline-flex items-center">
                  <svg className="w-3 h-3 mr-1 opacity-75" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                  Twitter
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-6 pt-4 border-t border-neutral-100 flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="pl-14 text-slate-400 text-xs">
            © {new Date().getFullYear()} Arterra.AI Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
